import $ from 'jquery';

const $interferer = $('.interferer');
const $interfererClose = $('.interferer__close');

if (sessionStorage.getItem("hideInterferer") === '1') {
    $interferer.addClass('hidden');
} else {
    $interferer.addClass('visible');
}

toggleVisibility();
$(document).on('scroll', function () {
    toggleVisibility();
});
$interferer.on('click', function (e) {

    if (!$(e.target).hasClass('interferer__close')
        && $(e.target).closest('.interferer__close').length === 0
        && !$(this).hasClass('visible')
        && !$(this).hasClass('force-visible')
    ) {
        e.preventDefault();
        $(this).addClass('force-visible');
    }
})

$interfererClose.on('click', function (e) {
    e.preventDefault();
    $interferer.removeClass('visible');
    $interferer.removeClass('force-visible');
    $interferer.addClass('hidden');
    sessionStorage.setItem("hideInterferer", '1');
})

function toggleVisibility() {
    if (!$interferer.hasClass('hidden')) {
        if ($(window).width() > 768) {
            if ($(document).scrollTop() < 720) {
                $interferer.addClass('visible');
            } else {
                $interferer.removeClass('visible');
            }
        } else {
            if ($(document).scrollTop() < 200) {
                $interferer.addClass('visible');
            } else {
                $interferer.removeClass('visible');
            }
        }
    }

    if ($(window).width() > 768) {
        $interferer.removeClass('interferer--small');
    } else {
        if ($(document).scrollTop() < 200) {
            $interferer.addClass('interferer--small');
        } else {
            $interferer.removeClass('interferer--small');
        }
    }
}
